__turbopack_context__.v({
  "container": "xqng2W_container",
  "text": "xqng2W_text",
  "tooltipPaper": "xqng2W_tooltipPaper",
});
